import { FC } from 'react'
import { Select } from 'antd'
import { TargetCorrectionPaymentAllowedYearsDto } from '../../../types'
const Option = Select.Option

export interface PerTargetCorrectionPaymentCycleDropDownProps {
  value: string
  currentAppraisalSeasonYear: number
  targetCorrectionPaymentAllowedYears: TargetCorrectionPaymentAllowedYearsDto
  disabled?: boolean
  onBlur: (nextDate: string) => void
  onChange: (value: string) => void
}

export const PerTargetCorrectionPaymentCycleDropDown: FC<PerTargetCorrectionPaymentCycleDropDownProps> = ({
  value,
  currentAppraisalSeasonYear,
  targetCorrectionPaymentAllowedYears,
  disabled,
  onBlur,
  onChange,
}) => {
  const getCycleToDateFromMap = (key: string): string => {
    if (key === 'currentYear') {
      return `${currentAppraisalSeasonYear}`
    }
    return `${currentAppraisalSeasonYear - 1}`
  }

  const currentlySelectedOption = (): string => {
    const currentYear = `${currentAppraisalSeasonYear}`
    const previousYear = `${currentAppraisalSeasonYear - 1}`
    if (value === currentYear) {
      return 'currentYear'
    } else if (value === previousYear) {
      return 'previousYear'
    } else {
      return 'previousYear'
    }
  }

  return (
    <>
      <Select
        optionFilterProp="children"
        onChange={(optionName: string) => onChange(getCycleToDateFromMap(optionName))}
        onBlur={(optionName: string) => onBlur(getCycleToDateFromMap(optionName))}
        value={currentlySelectedOption()}
        disabled={disabled}
      >
        <Option value="currentYear" disabled={!targetCorrectionPaymentAllowedYears.currentYearAllowed}>
          {currentAppraisalSeasonYear}
        </Option>
        <Option value="previousYear" disabled={!targetCorrectionPaymentAllowedYears.previousYearAllowed}>
          {currentAppraisalSeasonYear - 1}
        </Option>
      </Select>
    </>
  )
}
